export const defaultImage = '/assets/images/qurban/default.jfif';
export const qurbanCode = 'qurban';
export const datas = [
    {
        id: 2,
        slug: 'qurban-sapi-super',
        name: 'Qurban Sapi Super 1/7',
        donasi: 2700000,
        deskripsi: `orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of <b><i>Lorem Ipsum.</i></b>`,
        user: {
            name: 'Baznas Sumedang',
            file: 'upload//jpg/F-1648519015.jpg'
        },
        is_1per7: true
    },
    {
        id: 3,
        slug: 'qurban-sapi-perah',
        name: 'Qurban Sapi Perah',
        donasi: 35700000,
        deskripsi: `orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of <b><i>Lorem Ipsum.</i></b>`,
        user: {
            name: 'Baznas Sumedang',
            file: 'upload//jpg/F-1648519015.jpg'
        },
        is_1per7: false
    },
    {
        id: 9,
        slug: 'qurban-domva',
        name: 'Qurban Domba Garut',
        donasi: 3200000,
        deskripsi: `lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of <b><i>Lorem Ipsum.</i></b>`,
        user: {
            name: 'Baznas Sumedang',
            file: 'upload//jpg/F-1648519015.jpg'
        },
        is_1per7: true
    }
];